import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const safetyChecklist = [
  { factor: 'Personal Information', action: 'Never share sensitive data in spreadsheets or public forums' },
  { factor: 'Link Verification', action: 'Always verify product links before clicking; use official sources' },
  { factor: 'Seller Research', action: 'Check seller ratings, reviews, and transaction history before purchasing' },
  { factor: 'QC Photo Review', action: 'Learn to analyze QC photos for quality indicators and potential issues' },
  { factor: 'Payment Security', action: 'Use secure payment methods with buyer protection features enabled' },
  { factor: 'Spreadsheet Sources', action: 'Only download spreadsheets from trusted, verified community members' },
];

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="lg:w-2/5">
            <div className="w-full aspect-square max-w-[400px] bg-secondary-500 rounded-3xl flex items-center justify-center">
              <div className="w-24 h-24 md:w-32 md:h-32 flex items-center justify-center rounded-full bg-white/20">
                <i className="ri-shield-check-line text-5xl md:text-6xl text-white"></i>
              </div>
            </div>
          </div>

          <div className="lg:w-3/5">
            <span className="inline-block text-xs font-medium text-foreground-400 bg-background-200/70 px-3 py-1 rounded-full mb-4">
              Buyer Protection
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-8">
              Shop Confidently With{' '}
              <span className="text-foreground-400">Verified Resources</span>
            </h2>

            <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-10 pl-4 border-l-2 border-accent-500">
              &ldquo;We educate the community about protecting personal information, avoiding suspicious links,
              checking seller credentials, reviewing QC photos thoroughly, and always using secure payment methods.
              Our mission is to make international shopping safer and more transparent for everyone using Superbuy
              Spreadsheet resources. Every guide we publish undergoes rigorous review by our safety team.&rdquo;
            </blockquote>

            <p className="text-xs text-foreground-400 mb-10">
              — <strong className="text-foreground-700">Superbuy Safety Team</strong>
            </p>

            <div className="space-y-3">
              <h3 className="font-semibold text-sm text-foreground-800 mb-4">Safety Checklist</h3>
              {safetyChecklist.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-3 p-3 rounded-lg bg-background-50"
                >
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </div>
                  <div>
                    <span className="text-sm font-semibold text-foreground-800 block">
                      {item.factor}
                    </span>
                    <span className="text-xs text-foreground-500">{item.action}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all"
              >
                Shop Safely Now
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/superbuy-spreadsheet-beginner-guide"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-foreground-200 text-foreground-700 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-foreground-100 transition-all"
              >
                Read Safety Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}